import React from 'react';

import { fetchBV } from '../bv-actions.js';
import ScriptLoader from '../../page/components/script-loader'

const BV_URL = 'https://apps.bazaarvoice.com/deployments/hp/single_page_application/production/en_US/bv.js';

class BvScript extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidUpdate(prevProps) {
        if(prevProps.sku !== this.props.sku && this.props.scriptLoaded) {
            fetchBV(this.props.sku);
        }
    }

    render() {
        return(
            <ScriptLoader
                url={BV_URL}
                name='bv'
            />
        )
    }
}


export default BvScript
